export default "__VITE_ASSET__D4H$zqgJ__"